export default __webpack_public_path__ + "static/media/hero_poster.9f7530e7.webp";